import axios from 'axios';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import { MaterialModel } from 'src/models/services/material';

const API_Controller = '/materials';

export const MaterialsService = {
  getAllData: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as MaterialModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: MaterialModel) => {
    const reModel = {
      Name: dataToAdd.name,
      Description: dataToAdd.description,
      UnitOfMeasuresId: dataToAdd.unitOfMeasure.id,
      Status: dataToAdd.status
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, reModel);
      enqueueSnackbar(`Material Added Successfully`, {
        variant: 'success'
      });
      return response.data as MaterialModel[];
    } catch (error) {
      throw error;
    }
  },

  editData: async (dataToUpdate: MaterialModel) => {
    const reModel = {
      Id: dataToUpdate.id,
      Name: dataToUpdate.name,
      Description: dataToUpdate.description,
      Status: dataToUpdate.status,
      UnitOfMeasuresId: dataToUpdate.unitOfMeasure.id
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`Material edited Successfully`, {
        variant: 'success'
      });
      const dataToUpdateBack = {
        ...respons.data,
        unitOfMeasures: dataToUpdate.unitOfMeasure
      };
      return dataToUpdateBack as MaterialModel[];
    } catch (error) {
      enqueueSnackbar(`Material edit unsuccessfull`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteData: async (deleteId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`Material deleted Successfully`, {
        variant: 'success'
      });
      return response.data as MaterialModel[];
    } catch (error) {
      enqueueSnackbar(`Material delete unsuccessfull, assinged to Service.`, {
        variant: 'error'
      });
      throw error;
    }
  }
};
